import { CUSTOM_WIDGET_TYPES } from 'reporting-data/tsTypes/customWidgetTypes';
export const registerCustomWidgetPlugins = registerPlugin => {
  registerPlugin(CUSTOM_WIDGET_TYPES.ENGAGEMENT_STREAM, () => import( /* webpackChunkName: "examplePlugins" */'./engagementStream/Plugin'));
};